<script lang="ts">
    import { _ } from "svelte-i18n";
    import { appManager } from "./AppManagerStore";
</script>

<section class="py-6 py-md-8 bg-gray-200">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-lg-10 text-center">
                <span class="badge badge-pill badge-primary-desat-soft mb-3">
                    <span class="h6 text-uppercase"
                        >{$_("logos.tag1")}</span>
                </span>

                <h2>{$_("logos.title")}</h2>

                <p class="lead text-muted mb-7 mb-md-9">
                    {$_("logos.part1")}
                    <strong>{$_("logos.part2")}</strong>
                    {$_("logos.part3")}
                </p>
            </div>
        </div>
        <div class="row align-items-center justify-content-center">
            <div class="col-12 text-center client-logos-small">
                <img
                    src="{$appManager.PublicUrl}img/clients/wevelgem.svg"
                    alt="Wevelgem" />
                <img
                    src="{$appManager.PublicUrl}img/clients/wingene.svg"
                    alt="Wingene" />
                <img
                    src="{$appManager.PublicUrl}img/clients/kortrijk.svg"
                    alt="Kortrijk" />
                <img
                    src="{$appManager.PublicUrl}img/clients/asse.svg"
                    alt="Asse" />
                <img
                    src="{$appManager.PublicUrl}img/clients/rotselaar.png"
                    alt="Rotselaar" />
                <img
                    src="{$appManager.PublicUrl}img/clients/beerse.svg"
                    alt="Beerse" />
                <img
                    src="{$appManager.PublicUrl}img/clients/dilbeek.png"
                    alt="Dilbeek" />
                <img
                    src="{$appManager.PublicUrl}img/clients/sint-niklaas.svg"
                    alt="Sint-Niklaas" />
                <img
                    src="{$appManager.PublicUrl}img/clients/hasselt.png"
                    alt="Hasselt" />
                <img
                    src="{$appManager.PublicUrl}img/clients/stad-mechelen.png"
                    alt="Mechelen" />
                <img
                    src="{$appManager.PublicUrl}img/clients/machelen.svg"
                    alt="Stad Mechelen" />
                <img
                    src="{$appManager.PublicUrl}img/clients/stad-brussel.png"
                    alt="Brussel" />
                <img
                    src="{$appManager.PublicUrl}img/clients/tienen.png"
                    alt="Tienen" />
                <img
                    src="{$appManager.PublicUrl}img/clients/herentals.svg"
                    alt="Herentals" />
                <img
                    src="{$appManager.PublicUrl}img/clients/torhout.svg"
                    alt="Torhout" />
                <img
                    src="{$appManager.PublicUrl}img/clients/keerbergen.svg"
                    alt="Keerbergen" />
                <img
                    src="{$appManager.PublicUrl}img/clients/machelen.svg"
                    alt="Machelen" />
                <img
                    src="{$appManager.PublicUrl}img/clients/meerhout.svg"
                    alt="Meerhout" />
                <img
                    src="{$appManager.PublicUrl}img/clients/haaght.svg"
                    alt="Haaght" />
                <img
                    src="{$appManager.PublicUrl}img/clients/beringen.svg"
                    alt="Beringen" />
                <img
                    src="{$appManager.PublicUrl}img/clients/gent.png"
                    alt="Gent" />
                <img
                    src="{$appManager.PublicUrl}img/clients/vilvoorde.svg"
                    alt="Vilvoorde" />
                <img
                    src="{$appManager.PublicUrl}img/clients/oostkamp.jpg"
                    alt="Oostkamp" />
                <img
                    src="{$appManager.PublicUrl}img/clients/oud-heverlee.png"
                    alt="Oud-Heverlee" />
                <img
                    src="{$appManager.PublicUrl}img/clients/antwerpen.png"
                    alt="Antwerpen" />
                <img
                    src="{$appManager.PublicUrl}img/clients/leuven.png"
                    alt="Leuven" />
                <img
                    src="{$appManager.PublicUrl}img/clients/bergen-op-zoom.png"
                    alt="Bergen-op-zoom" />
                <img
                    src="{$appManager.PublicUrl}img/clients/provincie-vlaams-brabant.svg"
                    alt="Provincie Vlaams-Brabant" />
            </div>
        </div>
        <!-- / .row -->
    </div>
    <!-- / .container -->
</section>
